import React from 'react'
import '../Blog.css'

const BlogHead = () => {
  return (
    <div className='container-fluid bloghead w-100 px-5 py-3'>
      <h1 className='fw-bolder'>Blog</h1>
    </div>
  )
}

export default BlogHead;